<div *ngIf="taskOptionsService.selectedBoard"
     class="pb-5">
    <h1>{{ 'TASKS.SETTINGS.TEXT.BOARD_ACCESS' | translate }}</h1>
    <div class="mt-1 mb-2">
        <button (click)="openCreateModal('department', addPermissionsView)"
                [disabled]="taskOptionsService.isPermissionsChanged"
                class="btn btn-primary ms-1"
                data-action='addDepartment'
        >
            {{ 'TASKS.BUTTONS.ADD_DEPARTMENT' | translate }}
        </button>
        <button (click)="openCreateModal('division', addPermissionsView)"
                [disabled]="taskOptionsService.isPermissionsChanged"
                class="btn btn-primary ms-1"
                data-action='addDivision'
        >
            {{ 'TASKS.BUTTONS.ADD_DIVISION' | translate }}
        </button>
        <button (click)="openCreateModal('member', addPermissionsView)"
                [disabled]="taskOptionsService.isPermissionsChanged"
                class="btn btn-primary ms-1"
                data-action='addMember'
        >
            {{ 'TASKS.BUTTONS.ADD_MEMBER' | translate }}
        </button>
    </div>
    <table class="table default-table table-tasks gbo_shadow">
        <thead>
        <tr>
            <td></td>
            <td>
                <strong>{{ 'TASKS.SETTINGS.ACCESS.TYPE' | translate }}</strong>
            </td>
            <td>
                <strong>{{ 'TASKS.SETTINGS.ACCESS.NAME' | translate }}</strong>
            </td>
            <td *ngFor="let col of structure">
                <strong>{{ 'TASKS.SETTINGS.ACCESS.' + col.right | translate }}</strong>
            </td>
            <td></td>
        </tr>
        </thead>
        <tbody>
        <tr class="table-info">
            <td colspan="12"><strong>{{ 'TASKS.SETTINGS.ACCESS.DEPARTMENTS' | translate }}</strong></td>
        </tr>
        <tr *ngIf="!departmentBoardRights.length">
            <td class="align-center"
                colspan="11">
                <span>{{ 'EMPTY_LISTS.EMPTY' | translate }}</span>
            </td>
        </tr>
        <ng-container *ngFor="let permission of departmentBoardRights; let i = index">
            <ng-container
                    *ngTemplateOutlet="perms; context: {permission: permission, i: i, permissionsType: 'departments'}"
            ></ng-container>
        </ng-container>

        <tr class="table-info">
            <td colspan="12"><strong>{{ 'TASKS.SETTINGS.ACCESS.DIVISIONS' | translate }}</strong></td>
        </tr>
        <tr *ngIf="!divisionBoardRights.length">
            <td class="align-center"
                colspan="11">
                <span>{{ 'EMPTY_LISTS.EMPTY' | translate }}</span>
            </td>
        </tr>
        <ng-container *ngFor="let permission of divisionBoardRights; let i = index">
            <ng-container
                    *ngTemplateOutlet="perms; context: {permission: permission, i: i, permissionsType: 'divisions'}"
            ></ng-container>
        </ng-container>

        <tr class="table-info">
            <td colspan="12"><strong>{{ 'TASKS.SETTINGS.ACCESS.MEMBERS' | translate }}</strong></td>
        </tr>
        <tr *ngIf="!userBoardRights.length">
            <td class="align-center"
                colspan="11">
                <span>{{ 'EMPTY_LISTS.EMPTY' | translate }}</span>
            </td>
        </tr>
        <ng-container *ngFor="let permission of userBoardRights; let i = index">
            <ng-container
                    *ngTemplateOutlet="perms; context: {permission: permission, i: i, permissionsType: 'members'}"
            ></ng-container>
        </ng-container>

        <ng-template #perms
                     let-i="i"
                     let-permission="permission"
                     let-permissionsType="permissionsType">
            <tr class="table-item table-light">
                <td>
                    <i (click)="openPermission(permission)"
                       *ngIf="permissionsType !== 'members' && currentMember.project_setting.is_project_admin"
                       [class]="permission.isOpen ? 'bi bi-caret-down' : 'bi bi-caret-right'"
                    ></i>
                </td>
                <td>
                    <i *ngIf="permission.role_type === 'department'"
                       class="bi bi-collection"
                       ngbTooltip="{{ 'TASKS.TEXT.DEPARTMENT' | translate }}"
                    ></i>
                    <i *ngIf="permission.role_type === 'member'"
                       class="bi bi-person"
                       ngbTooltip="{{ 'TASKS.TEXT.MEMBER' | translate }}"
                    ></i>
                    <i *ngIf="permission.role_type === 'division'"
                       class="bi bi-people"
                       ngbTooltip="{{ 'TASKS.TEXT.DIVISION' | translate }}"
                    ></i>
                </td>
                <td>
                    <span (click)="helper.openProfileByGuid(permission.role.guid)"
                          *ngIf="permission.role_type === 'member'"
                          [class.blocked_user]="permission.role.observation_type === 'blocked'"
                          [class.inactive_user]="!permission.role.is_active"
                          class="user_name"
                    >
                        {{ helper.shortFullName(permission.role) }}
                    </span>
                    <span *ngIf="['division', 'department'].includes(permission.role_type)">{{ permission.role.name }}</span>
                </td>

                <td *ngFor="let col of structure"
                    style="text-align: center"
                >
                    <select #permissionSelect
                            (change)="changePermissions(permission, col.right, permissionSelect.value)"
                            [class.disabled]="!col.is_editing"
                            [class.permission-changed]="copyPermissions[permissionsType][i][col.right] !== permission[col.right]"
                            [class]="permission[col.right] ? 'active' : 'admin'"
                            class="form-select-sm"
                            data-action="changeIsReadAllTasks"
                    >
                        <option [selected]="copyPermissions[permissionsType][i][col.right] === 'succession'"
                                value="succession"
                        >
                            {{ 'TASKS.SETTINGS.ACCESS.VALUE.succession'| translate }}
                        </option>
                        <option [selected]="copyPermissions[permissionsType][i][col.right] === 'allowed'"
                                value="allowed"
                        >
                            {{ 'TASKS.SETTINGS.ACCESS.VALUE.allowed'| translate }}
                        </option>
                        <option [selected]="copyPermissions[permissionsType][i][col.right] === 'denied'"
                                value="denied"
                        >
                            {{ 'TASKS.SETTINGS.ACCESS.VALUE.denied'| translate }}
                        </option>
                    </select>
                </td>

                <td style="text-align: center">
                    <button (click)="deleteAccess(permission)"
                            [disabled]="taskOptionsService.isPermissionsChanged"
                            class="btn btn-danger btn-sm"
                    >
                        <i class="bi bi-trash"></i>
                    </button>
                </td>
            </tr>
            <ng-container *ngIf="permission.isOpen">
                <tr *ngFor="let member of permission.members"
                    class="table-item table-secondary">

                    <td></td>
                    <td>
                        <i class="bi bi-person"
                           ngbTooltip="{{ 'TASKS.TEXT.MEMBER' | translate }}"></i>
                    </td>
                    <td>
                        <span (click)="helper.openProfileByGuid(member.guid)"
                              [class.blocked_user]="member.observation_type === 'blocked'"
                              [class.inactive_user]="!member.is_active"
                              class="user_name"
                        >
                            {{ helper.shortFullName(member) }}
                        </span>
                    </td>

                    <td *ngFor="let col of structure"
                        style="text-align: center">
                    <span [class]="permission[col.right] ? 'active' : ''"
                          class="stat__col__icon admin disabled"
                          data-action="changeIsReadAllTasks"
                    >
                        {{ permission[col.right] }}
                    </span>
                    </td>

                    <td></td>
                </tr>
            </ng-container>
        </ng-template>
        </tbody>
    </table>
</div>

<div *ngIf="taskOptionsService.isPermissionsChanged"
     class="fixed-button">
    <div class="btn-group btn-block w-100">
        <button (click)="savePermissions()"
                class="btn btn-success"
                data-action="saveRoadmapButton"
        >
            {{ 'BUTTON_TEXT.SAVE' | translate }}
        </button>
        <button (click)="cancelEditPermissions()"
                class="btn btn-primary"
                data-action="clearRoadmapChangesButton"
        >
            {{ 'BUTTON_TEXT.REVERT' | translate }}
        </button>
    </div>
</div>

<ng-template #addPermissionsView
             let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <ng-container [ngSwitch]="roleType">
            <ng-template ngSwitchCase="member">
                <h1>{{ 'MODALS.HEADERS.ADD_MEMBER' | translate }}</h1>
                <select #memberKey
                        (change)="roleKey = memberKey.value"
                        class="form-select">
                    <option hidden
                            selected
                            value="">{{ 'MODALS.FIELDS.SELECT.MEMBER' | translate }}
                    </option>
                    <option *ngIf="!allMembers.length"
                            disabled>{{ 'EMPTY_LISTS.EMPTY' | translate }}
                    </option>
                    <option *ngFor="let member of allMembers"
                            [value]="member.guid"
                    >
                        {{ helper.shortFullName(member) }}
                    </option>
                </select>
            </ng-template>

            <ng-template ngSwitchCase="department">
                <h1>{{ 'MODALS.HEADERS.ADD_DEPARTMENT' | translate }}</h1>
                <select #departmentKey
                        (change)="roleKey = departmentKey.value"
                        class="form-select">
                    <option hidden
                            selected
                            value="">{{ 'MODALS.FIELDS.SELECT.DEPARTMENTS' | translate }}
                    </option>
                    <option *ngIf="!allDepartments.length"
                            disabled>{{ 'EMPTY_LISTS.EMPTY' | translate }}
                    </option>
                    <option *ngFor="let department of allDepartments"
                            [value]="department.department_id"
                    >
                        {{ department.department_name }}
                    </option>
                </select>
            </ng-template>

            <ng-template ngSwitchCase="division">
                <h1>{{ 'MODALS.HEADERS.ADD_DIVISION' | translate }}</h1>
                <h2>{{ 'MODALS.FIELDS.SELECT.DEPARTMENTS' | translate }}</h2>
                <select [(ngModel)]="selectedDepartmentWithDivisions"
                        class="form-select">
                    <option [ngValue]="undefined"
                            hidden>{{ 'MODALS.FIELDS.SELECT.DEPARTMENTS' | translate }}
                    </option>
                    <option *ngIf="!allDepartments.length"
                            disabled>{{ 'EMPTY_FIELDS.EMPTY' | translate }}
                    </option>
                    <option *ngFor="let department of allDepartments"
                            [ngValue]="department"
                    >
                        {{ department.department_name }}
                    </option>
                </select>

                <div *ngIf="selectedDepartmentWithDivisions"
                     class="mb-2">
                    <h2 class="mt-1">{{ 'MODALS.FIELDS.SELECT.DIVISION' | translate }}</h2>
                    <div *ngFor="let divisionItemCont of selectedDepartmentWithDivisions.divisions"
                         class="division-item">
                        <ng-container
                                *ngTemplateOutlet="division; context: {divisionItem: divisionItemCont}"></ng-container>
                    </div>
                </div>
                <ng-template #division
                             let-divisionItem="divisionItem">
                    <div>
                        <div class="division-item item-head flex-display justify-content-between">
                            <div>
                                <i (click)="divisionSlider[divisionItem.id] = !divisionSlider[divisionItem.id]"
                                   *ngIf="divisionItem.subdivision.length"
                                   [class]="divisionSlider[divisionItem.id] ? 'bi bi-caret-down me-1 pointer' : 'bi bi-caret-right me-1 pointer'"
                                ></i>
                                <input (change)="roleKey = divisionItem.id"
                                       class="ms-2 me-1"
                                       name="checkDivision"
                                       type="radio">
                                <i class="bi-people me-1"
                                   ngbTooltip="{{ 'TASKS.TEXT.DIVISION' | translate }}"
                                ></i>
                                <span>{{ divisionItem.name }}</span>
                            </div>
                        </div>

                        <div *ngIf="divisionSlider[divisionItem.id]">
                            <div *ngFor="let divisionItem of divisionItem.subdivision"
                                 class="subdivision">
                                <ng-container
                                        *ngTemplateOutlet="division; context: {divisionItem: divisionItem}"></ng-container>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ng-template>
        </ng-container>

        <div class="input-group mt-3">
            <label class="input-group-text"
                   for="read-all-tasks"
            >
                {{ 'TASKS.SETTINGS.ACCESS.is_read_all_tasks' | translate }}
            </label>
            <select #readAllTasks
                    class="form-select"
                    id="read-all-tasks"
                    name="read-all-tasks"
            >
                <option hidden
                        selected
                        value="">Выбрать права
                </option>
                <option value="succession">{{ 'TASKS.SETTINGS.ACCESS.VALUE.succession'| translate }}</option>
                <option value="allowed">{{ 'TASKS.SETTINGS.ACCESS.VALUE.allowed'| translate }}</option>
                <option value="denied">{{ 'TASKS.SETTINGS.ACCESS.VALUE.denied'| translate }}</option>
            </select>
        </div>
        <div class="input-group mt-3">
            <label class="input-group-text"
                   for="is_create_new_task"
            >
                {{ 'TASKS.SETTINGS.ACCESS.is_create_new_task' | translate }}
            </label>
            <select #createTask
                    class="form-select"
                    id="is_create_new_task"
                    name="is_create_new_task"
            >
                <option hidden
                        selected
                        value="">Выбрать права
                </option>
                <option value="succession">{{ 'TASKS.SETTINGS.ACCESS.VALUE.succession'| translate }}</option>
                <option value="allowed">{{ 'TASKS.SETTINGS.ACCESS.VALUE.allowed'| translate }}</option>
                <option value="denied">{{ 'TASKS.SETTINGS.ACCESS.VALUE.denied'| translate }}</option>
            </select>
        </div>
        <div class="input-group mt-3">
            <label class="input-group-text"
                   for="is_create_new_comment"
            >
                {{ 'TASKS.SETTINGS.ACCESS.is_create_new_comment' | translate }}
            </label>
            <select #createComments
                    class="form-select"
                    id="is_create_new_comment"
                    name="is_create_new_comment"
            >
                <option hidden
                        selected
                        value="">Выбрать права
                </option>
                <option value="succession">{{ 'TASKS.SETTINGS.ACCESS.VALUE.succession'| translate }}</option>
                <option value="allowed">{{ 'TASKS.SETTINGS.ACCESS.VALUE.allowed'| translate }}</option>
                <option value="denied">{{ 'TASKS.SETTINGS.ACCESS.VALUE.denied'| translate }}</option>
            </select>
        </div>
        <div class="input-group mt-3">
            <label class="input-group-text"
                   for="is_set_property_val">
                {{ 'TASKS.SETTINGS.ACCESS.is_set_property_val' | translate }}
            </label>
            <select #setProperty
                    class="form-select"
                    id="is_set_property_val"
                    name="is_set_property_val"
            >
                <option hidden
                        selected
                        value="">Выбрать права
                </option>
                <option value="succession">{{ 'TASKS.SETTINGS.ACCESS.VALUE.succession'| translate }}</option>
                <option value="allowed">{{ 'TASKS.SETTINGS.ACCESS.VALUE.allowed'| translate }}</option>
                <option value="denied">{{ 'TASKS.SETTINGS.ACCESS.VALUE.denied'| translate }}</option>
            </select>
        </div>
        <div class="input-group mt-3">
            <label class="input-group-text"
                   for="is_edit_settings">
                {{ 'TASKS.SETTINGS.ACCESS.is_edit_settings' | translate }}
            </label>
            <select #editBoard
                    class="form-select"
                    id="is_edit_settings"
                    name="is_edit_settings"
            >
                <option hidden
                        selected
                        value="">Выбрать права
                </option>
                <option value="succession">{{ 'TASKS.SETTINGS.ACCESS.VALUE.succession'| translate }}</option>
                <option value="allowed">{{ 'TASKS.SETTINGS.ACCESS.VALUE.allowed'| translate }}</option>
                <option value="denied">{{ 'TASKS.SETTINGS.ACCESS.VALUE.denied'| translate }}</option>
            </select>
        </div>
        <div class="input-group mt-3">
            <label class="input-group-text"
                   for="is_set_self_in_task">
                {{ 'TASKS.SETTINGS.ACCESS.is_set_self_in_task' | translate }}
            </label>
            <select #setSelfInTask
                    class="form-select"
                    id="is_set_self_in_task"
                    name="is_set_self_in_task"
            >
                <option hidden
                        selected
                        value="">Выбрать права
                </option>
                <option value="succession">{{ 'TASKS.SETTINGS.ACCESS.VALUE.succession'| translate }}</option>
                <option value="allowed">{{ 'TASKS.SETTINGS.ACCESS.VALUE.allowed'| translate }}</option>
                <option value="denied">{{ 'TASKS.SETTINGS.ACCESS.VALUE.denied'| translate }}</option>
            </select>
        </div>
        <div class="input-group mt-2">
            <label class="input-group-text"
                   for="is_set_other_in_task">
                {{ 'TASKS.SETTINGS.ACCESS.is_set_other_in_task' | translate }}
            </label>
            <select #setOtherInTask
                    class="form-select"
                    id="is_set_other_in_task"
                    name="is_set_other_in_task"
            >
                <option hidden
                        selected
                        value="">Выбрать права
                </option>
                <option value="succession">{{ 'TASKS.SETTINGS.ACCESS.VALUE.succession'| translate }}</option>
                <option value="allowed">{{ 'TASKS.SETTINGS.ACCESS.VALUE.allowed'| translate }}</option>
                <option value="denied">{{ 'TASKS.SETTINGS.ACCESS.VALUE.denied'| translate }}</option>
            </select>
        </div>

        <button (click)="addPermissionsToBoard(readAllTasks.value,
                                                createTask.value,
                                                createComments.value,
                                                setProperty.value,
                                                editBoard.value,
                                                setSelfInTask.value,
                                                setOtherInTask.value,
                                                modal
                        )"
                [disabled]="isLockButton"
                class="btn btn-block btn-success"
                data-action='addDepartmentButton'
                style="margin-top: 10px;"
        >
            <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.ADD' | translate }}</span>
        </button>
    </div>
</ng-template>

<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>
